import { Vector3, Color3 } from '@babylonjs/core/Maths/math';
import { GridMaterial } from '@babylonjs/materials/grid/gridMaterial';
import { PlaneBuilder } from '@babylonjs/core/Meshes/Builders/planeBuilder';
import { Mesh } from '@babylonjs/core/Meshes/mesh';

import { SystemCamera } from '~/Scene/System/systemCamera';
import { EXPORT_FILTER_PREFIX } from '~/Scene/Tool/interface';
import { hexToRgbBabylon } from '~/Utils/color';

export class CanvasGridPlane {
    private plane: Mesh;

    private system: SystemCamera;

    constructor(system: SystemCamera) {
        this.system = system;
        // make sure plane is double sided
        this.plane = PlaneBuilder.CreatePlane(`${EXPORT_FILTER_PREFIX}gridplane`, { width: 1, height: 1, sideOrientation: 2 }, system.scene);
        const material = new GridMaterial(`${EXPORT_FILTER_PREFIX}gridMaterial`, system.scene);

        const color = hexToRgbBabylon('#333333');
        material.lineColor = color;
        material.mainColor = Color3.Black();
        material.gridRatio = system.visibleWorld * 0.002;
        material.minorUnitVisibility = 1;
        material.gridOffset = new Vector3(0.00003, 0.00003, 0);
        // Force opacity != 1 to have no main color on grid material and let the plane2 visible
        material.opacity = 0.1;
        this.plane.material = material;
        this.plane.rotation.x = Math.PI / 2;
        this.plane.scaling.scaleInPlace(system.visibleWorld);

        // Make sure we can't pick it or selection won't work
        this.plane.isPickable = false;
    }

    public show(): void {
        this.plane.isVisible = true;
        this.system.checkActiveMeshes();
    }

    public hide(): void {
        this.plane.isVisible = false;
        this.system.checkActiveMeshes();
    }
}
